import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as CashPaymentBagIcon } from '../../assets/images/svg/cash-payment-bag.svg';
import themeColors from '../../assets/styles/themeColors';

const CashPaymentBagIconStyled = styled(CashPaymentBagIcon)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  path {
    fill: ${({ color }) => color || themeColors.colorTextPrimary};
    stroke: ${({ stroke }) => stroke || 'none'};
  }
  circle {
    fill: ${({ cc }) => cc || themeColors.colorBackgroundPrimaryDark};
    stroke: ${({ cs }) => cs || 'none'};
  }
`;

const CashPaymentBag = (props) => <CashPaymentBagIconStyled {...props} />;

CashPaymentBag.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  circleColor: PropTypes.string,
  circleStroke: PropTypes.string,
};

CashPaymentBag.defaultProps = {
  w: '62px',
  h: '62px',
};

export default CashPaymentBag;
